import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

// Line-by-line masked reveal for headings.
export const MaskedLines = ({ lines, className = "", delay = 0, wordClass = "", lineClass = "" }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease: easing, delay: delay + i * 0.12 }}
        >
          <span className={wordClass}>{line}</span>
        </motion.span>
      </span>
    ))}
  </span>
);

// Scroll-triggered fade + rise for any block.
export const Reveal = ({ children, className = "", delay = 0, y = 34, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: easing, delay }}
  >
    {children}
  </motion.div>
);

// Word-stagger reveal for editorial paragraphs.
export const RevealWords = ({ text, className = "", delay = 0 }) => {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom">
          <motion.span
            className="inline-block"
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: easing, delay: delay + i * 0.02 }}
          >
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </span>
  );
};
